import type { Address } from "viem";

import { validateAllowance, validateBalance } from "../utils";
import { useAllowanceQuery, useBalanceQuery } from "../../../hooks";
import type { Currency } from "../types";

type Params = {
  currency: Pick<Currency, "address" | "decimals" | "symbol"> | undefined;
  spenderContractAddress: Address;
};

export const useValidateCurrencyRules = ({
  currency,
  spenderContractAddress,
}: Params) => {
  const balanceQuery = useBalanceQuery({
    currency,
  });
  const allowanceQuery = useAllowanceQuery({
    currencyAddress: currency?.address,
    contractAddress: spenderContractAddress,
  });

  return {
    validate: {
      balance: validateBalance({
        balance: balanceQuery.data?.balance,
        currency,
      }),
      allowance: validateAllowance({
        allowance: allowanceQuery.data,
        currency,
      }),
    },
  };
};
